var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon07(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "root",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "81.9px",
    height: "101.4px",
    viewBox: "0 0 81.9 101.4",
    style: {
      enableBackground: "new 0 0 81.9 101.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B0B0AE;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.6,30.7V41h10.4V30.7H46.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.5,24H23.8V8.4h15.7V24z M27.3,20.5H36v-8.7h-8.7V20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.5,43.7H23.8V28h15.7V43.7z M27.3,40.2H36v-8.7h-8.7V40.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.1,24H43.5V8.4h15.7V24z M46.9,20.5h8.7v-8.7h-8.7V20.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "18.9,10.7 15.5,10.7 15.5,0 26.1,0 26.1,3.5 18.9,3.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "67.5,10.7 64,10.7 64,3.5 56.8,3.5 56.8,0 67.5,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "18.9,10.7 15.5,10.7 15.5,0 26.1,0 26.1,3.5 18.9,3.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "67.5,10.7 64,10.7 64,3.5 56.8,3.5 56.8,0 67.5,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "26.1,52 15.5,52 15.5,41.3 18.9,41.3 18.9,48.5 26.1,48.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "67.5,52 56.8,52 56.8,48.5 64,48.5 64,41.3 67.5,41.3  "
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 29.9,
    y: 14.4,
    className: "st0",
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.9,
    y: 34.1,
    className: "st0",
    width: 3.5,
    height: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.6,
    y: 14.4,
    className: "st0",
    width: 3.5,
    height: 3.5
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.4,97C2.5,96.4,0,93,0,87.9c0-5.7,3.1-9.1,7.7-9.1s7.7,3.4,7.7,9.1c0,5-2.4,8.3-6,9c0.8,1.5,2.4,2.2,4.2,2.2 c0.8,0,1.4-0.1,1.9-0.3l0.5,2.1c-0.6,0.3-1.6,0.5-2.7,0.5C9.8,101.4,7.4,99.5,6.4,97z M12.5,87.9c0-4.2-1.9-6.7-4.8-6.7 s-4.8,2.5-4.8,6.7c0,4.3,1.9,6.9,4.8,6.9S12.5,92.1,12.5,87.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,79.1h5.8c3.6,0,6.4,1.3,6.4,5.1c0,2.7-1.5,4.4-3.7,5.1l4.3,7.5h-3.1l-4-7.1h-2.9v7.1H20V79.1z M25.5,87.4 c2.6,0,4-1.1,4-3.2c0-2.1-1.4-2.9-4-2.9h-2.7v6.1H25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.4,89.5c-1.5,1.2-3.3,2.4-4.9,3.2c1.5,1.8,3.6,3.1,6.1,3.9c-0.5,0.5-1.2,1.4-1.4,2c-5-1.8-7.9-5.5-9.6-10.8 c-1,0.9-2.1,1.8-3.4,2.6v5c1.8-0.4,3.7-0.9,5.6-1.3l0.2,2c-3.7,1-7.8,1.9-10.7,2.6l-0.7-2.1c1-0.2,2.1-0.5,3.3-0.7v-4.2 c-1.5,0.8-3,1.4-4.5,1.9c-0.3-0.6-1-1.4-1.4-1.8c3-0.8,6.4-2.4,8.7-4.2h-7.9v-1.9h9.3v-1.8h-7.3V82h7.3v-1.6h-8.4v-1.9h8.4v-1.8 h2.2v1.8H56v1.9h-8.6V82h7.7v1.8h-7.7v1.8h9.4v1.9h-8.1c0.5,1.4,1,2.6,1.8,3.8c1.5-0.9,3.1-2.2,4.2-3.2L56.4,89.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67,89c-1.1,2.9-3,5.7-4.8,7.6c-0.5-0.4-1.5-1-2.1-1.3c1.8-1.6,3.5-4.2,4.5-6.8L67,89z M81.9,84.1v2.2h-9.3 v9.7c0,1.3-0.3,2-1.3,2.3c-1,0.4-2.4,0.4-4.5,0.4C66.7,98,66.4,97,66,96.3c1.5,0,3.1,0.1,3.6,0c0.5,0,0.6-0.1,0.6-0.5v-9.6h-9.4 v-2.2H81.9z M79.7,80.5H63v-2.2h16.8V80.5z M77.7,88.3c1.7,2.3,3.5,5.2,4.2,7.2l-2.3,1c-0.6-2-2.3-5.1-4-7.4L77.7,88.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon07);
export default __webpack_public_path__ + "static/media/icon_07.7d2cd0ddeedc6f2461c53f93204ed20e.svg";
export { ForwardRef as ReactComponent };